import React, { Component } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { fetchBz, createAdjustedBz } from '../actions'
import Chart from '../components/Chart'
import { YELLOW, ORANGE, RED, GREEN, BLACK } from '../constants/colors'
import { BZ_HIGH, BZ_MODERATE } from '../constants/thresholds'
import {BZ_URLS, Option} from '../constants/urls'

let BZ_SETTINGS = {
  softMax: 10,
  softMin: -10,
  unit: ' nT',
  yPlotLines: [
    {
      color: 'black',
      width: 2,
      value: 0,
    },
  ],
  xPlotLines: [],
}

const X_PLOT_LINE_SETTINGS = {
  color: BLACK,
  width: 1,
  zIndex: 10,
}

const BZ_ZONES = [
  {
    value: BZ_HIGH,
    color: RED,
  },
  {
    value: BZ_MODERATE,
    color: ORANGE,
  },
  {
    value: 0,
    color: YELLOW,
  },
  {
    color: GREEN,
    dashStyle: 'shortDot',
  },
]

const BZ_CHART = {
  name: 'Bz',
  type: 'line',
  zones: BZ_ZONES,
  color: YELLOW,
}

const BZ_ADJUSTED = {
  name: 'Estimated status at Earth',
  type: 'scatter',
  tooltip: {
    crosshairs: true,
    pointFormat: '<b>{point.x:%H:%M}</b><br/>Density: <b>{point.y}</b><br/>',
  },
  zones: BZ_ZONES,
  color: ORANGE,
}

class BzChartContainer extends Component<PropsFromRedux> {
  componentDidMount() {
    const { period, fetchBz } = this.props
    fetchBz(BZ_URLS[period])
  }

  componentDidUpdate(oldProps: PropsFromRedux) {
    const {speedConversions, bZ} = this.props

    if (speedConversions && bZ.length && !this.props.bZAtEarth) {
      this.props.createAdjustedBz(bZ, speedConversions)
    }
  }

  getXPlotLines() {
    return [
      {
        ...X_PLOT_LINE_SETTINGS,
        value: this.props.currentTime.getTime(),
      },
    ]
  }

  getBZSettings() {
    return {
      ...BZ_SETTINGS,
      xPlotLines: this.getXPlotLines(),
    }
  }

  render() {
    const {bZ, bZAtEarth} = this.props

    if (!bZAtEarth)
      return null

    const series = {
      ...BZ_CHART,
      data: bZ,
    }
    const secondarySeries = {
      ...BZ_ADJUSTED,
      data: this.props.bZAtEarth,
    }
    const { error } = this.props

    return (
      <Chart
        id="bz"
        title="Bz"
        series={series}
        secondarySeries={secondarySeries}
        settings={this.getBZSettings()}
        error={error}
      />
    )
  }
}

interface BzContainerState {
  bZ: any
  currentTime: any
  period: Option
  speed: any
}

function mapState(state: BzContainerState) {
  const { bZ, speed, currentTime, period } = state
  const {speedConversions} = speed
  return {
    bZ: bZ.data,
    bZAtEarth: bZ.bZAtEarth,
    speedConversions,
    currentTime: currentTime,
    period: period,
    error: bZ.error,
  }
}

const mapDispatch = {
  fetchBz,
  createAdjustedBz,
}

const connector = connect(mapState, mapDispatch)

type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(BzChartContainer)
